import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import {
  Psychology,
  FlashOn,
  TrendingUp,
  Assessment,
  Notes,
} from '@mui/icons-material';
import { PromptItem, InfoItem } from './shared';
import { formatPromptingLevel } from './utils';

const DetailsTab = ({ goalData }) => {
  return (
    <Grid container spacing={4}>
      {goalData?.DataCollection?.antecedent?.Antecedent && (
        <InfoItem
          icon={<Psychology fontSize='small' color='action' />}
          label='Antecedent'
          value={goalData?.DataCollection?.antecedent?.Antecedent}
          xs={12}
          sm={4}
        />
      )}

      {goalData?.DataCollection?.precedingBehavior?.PrecedingBehavior && (
        <InfoItem
          icon={<Psychology fontSize='small' color='action' />}
          label='Preceding Behavior'
          value={goalData?.DataCollection?.precedingBehavior?.PrecedingBehavior}
          xs={12}
          sm={4}
        />
      )}

      {goalData?.DataCollection?.targetBehavior?.TargetBehavior && (
        <InfoItem
          icon={<TrendingUp fontSize='small' color='action' />}
          label='Target Behavior'
          value={goalData?.DataCollection?.targetBehavior?.TargetBehavior}
          xs={12}
          sm={4}
        />
      )}

      {goalData?.DataCollection?.Baseline && (
        <InfoItem
          icon={<Assessment fontSize='small' color='action' />}
          label='Baseline'
          value={goalData?.DataCollection?.Baseline}
          xs={12}
          sm={4}
        />
      )}

      {goalData?.DataCollection?.PromptingApplicable?.isPromptingApplicable ===
        'Yes' && (
        <Grid item xs={12}>
          <Box sx={{ mt: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <FlashOn fontSize='small' color='action' />
              <Typography variant='h6' sx={{ fontWeight: 600 }}>
                Prompting:{' '}
                {goalData?.DataCollection?.PromptingApplicable?.PromptingType}
              </Typography>
            </Box>

            {(goalData?.DataCollection?.PromptingApplicable?.PromptingType ===
              'IVP, DVP, PVP, GP, PP' ||
              goalData?.DataCollection?.PromptingApplicable?.PromptingType ===
                'I, VP (IVP, DVP, PVP), GP, PP, ViP, M') && (
              <Grid container spacing={2}>
                <PromptItem
                  label='I'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.I
                  )}
                />
                <PromptItem
                  label='VP'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.VP
                  )}
                />
                <PromptItem
                  label='IVP'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.IVP
                  )}
                />
                <PromptItem
                  label='DVP'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.DVP
                  )}
                />
                <PromptItem
                  label='PVP'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.PVP
                  )}
                />
                <PromptItem
                  label='GP'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.GP
                  )}
                />
                <PromptItem
                  label='PP'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.PP
                  )}
                />
                <PromptItem
                  label='ViP'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.ViP
                  )}
                  ƒ
                />
                <PromptItem
                  label='M'
                  value={formatPromptingLevel(
                    goalData?.DataCollection?.PromptingApplicable?.M
                  )}
                />
              </Grid>
            )}

            {goalData?.DataCollection?.PromptingApplicable?.PromptingType ===
              'P+ & P-' && (
              <Grid container spacing={3}>
                <PromptItem
                  label='P+'
                  value={goalData?.DataCollection?.PromptingApplicable?.pPlus}
                  xs={6}
                />
                <PromptItem
                  label='P-'
                  value={goalData?.DataCollection?.PromptingApplicable?.pMinus}
                  xs={6}
                />
              </Grid>
            )}
          </Box>
        </Grid>
      )}

      {goalData?.dataCollection?.DataCollection?.PromptingApplicable
        ?.isPromptingApplicable === 'Yes' && (
        <Grid item xs={12}>
          <Box sx={{ mt: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <FlashOn fontSize='small' color='action' />
              <Typography variant='h6' sx={{ fontWeight: 600 }}>
                Prompting:{' '}
                {
                  goalData?.dataCollection?.DataCollection?.PromptingApplicable
                    ?.PromptingType
                }
              </Typography>
            </Box>

            {(goalData?.dataCollection?.DataCollection?.PromptingApplicable
              ?.PromptingType === 'IVP, DVP, PVP, GP, PP' ||
              goalData?.dataCollection?.DataCollection?.PromptingApplicable
                ?.PromptingType ===
                'I, VP (IVP, DVP, PVP), GP, PP, ViP, M') && (
              <Grid container spacing={2}>
                <PromptItem
                  label='I'
                  value={formatPromptingLevel(
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.I
                  )}
                />
                <PromptItem
                  label='VP'
                  value={formatPromptingLevel(
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.VP
                  )}
                />
                <PromptItem
                  label='IVP'
                  value={formatPromptingLevel(
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.IVP
                  )}
                />
                <PromptItem
                  label='DVP'
                  value={formatPromptingLevel(
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.DVP
                  )}
                />
                <PromptItem
                  label='PVP'
                  value={formatPromptingLevel(
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.PVP
                  )}
                />
                <PromptItem
                  label='GP'
                  value={formatPromptingLevel(
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.GP
                  )}
                />
                <PromptItem
                  label='PP'
                  value={formatPromptingLevel(
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.PP
                  )}
                />
              </Grid>
            )}

            {goalData?.dataCollection?.DataCollection?.PromptingApplicable
              ?.PromptingType === 'P+ & P-' && (
              <Grid container spacing={3}>
                <PromptItem
                  label='P+'
                  value={
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.pPlus
                  }
                  xs={6}
                />
                <PromptItem
                  label='P-'
                  value={
                    goalData?.dataCollection?.DataCollection
                      ?.PromptingApplicable?.pMinus
                  }
                  xs={6}
                />
              </Grid>
            )}
            {}
          </Box>
        </Grid>
      )}
      {goalData?.DataCollection?.Notes && (
        <Grid item xs={12}>
          <Box sx={{ mt: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Notes fontSize='small' color='action' />
              <Typography variant='h6' sx={{ fontWeight: 600 }}>
                Notes
              </Typography>
            </Box>
            <Paper
              variant='outlined'
              sx={{
                p: 3,
                bgcolor: '#f8f9ff',
                borderRadius: '12px',
                border: '1px solid #e0e0e0',
              }}
            >
              <Typography
                variant='body1'
                sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}
              >
                {goalData?.DataCollection?.Notes || 'No notes available'}
              </Typography>
            </Paper>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default DetailsTab;
